// Mock data for Vandana S. Personal Website

export const personalData = {
  hero: {
    name: "Vandana S.",
    headline: "Founder of Happy Lab • Psychologist • Content Creator • Entrepreneur",
    introduction: "For the past six years, I've been helping people understand themselves better through psychology, storytelling and education.",
    cta: [
      { text: "Explore My Work", href: "#work" },
      { text: "Watch My Content", href: "#content" },
      { text: "Work With Me", href: "#collaborate" }
    ]
  },

  stats: {
    title: "Impact & Reach",
    items: [
      { number: "6+", label: "Years Creating Content" },
      { number: "50+", label: "Podcast Episodes" },
      { number: "2", label: "Courses Launched" },
      { number: "5000+", label: "Students Reached" }
    ]
  },

  hero: {
    name: "Vandana S.",
    headline: "Founder of Happy Lab • Psychologist • Content Creator • Entrepreneur",
    introduction: "For the past six years, I've been helping people understand themselves better through psychology, storytelling and education.",
    cta: [
      { text: "Explore My Work", href: "#work" },
      { text: "Watch My Content", href: "#content" },
      { text: "Work With Me", href: "#collaborate" }
    ]
  },

  about: {
    title: "Who I Am",
    fullIntro: "I'm the Founder and Lead Counsellor at Happy Lab, where I've conducted more than 2,000 counselling sessions with individuals, couples, founders and traders. I'm also a Happiest Health Expert, contributing research-based articles on mental health. Outside the therapy room, I create educational content, build products and research how people think, make decisions and build meaningful lives. I believe every person has a story worth understanding.",
    highlights: [
      { label: "Founder of Happy Lab", icon: "building" },
      { label: "Happiest Health Expert", icon: "pen" },
      { label: "6+ years as Counsellor", icon: "heart" },
      { label: "2,000+ counselling sessions", icon: "users" },
      { label: "Psychology Educator", icon: "book" },
      { label: "Entrepreneur", icon: "rocket" },
      { label: "Curious Traveller", icon: "globe" }
    ]
  },

  projects: [
    {
      title: "Happy Lab",
      description: "Founded Happy Lab to make therapy more approachable, evidence-based and accessible. Rated 4.9/5 on Google with 200+ reviews.",
      link: "https://happylab.app",
      category: "Mental Health Platform",
      image: "happylab"
    },
    {
      title: "learn.happylab.app",
      description: "Built an online learning platform where psychology students practise counselling through supervised mock sessions, receive structured feedback and improve practical counselling skills.",
      link: "https://learn.happylab.app",
      category: "EdTech",
      image: "learn"
    },
    {
      title: "Trading Psychology",
      description: "Designed programmes helping traders understand emotions, patience, discipline, decision making and risk management. Watch the 10-minute introduction video.",
      link: "/videos/trading-psychology.mp4",
      category: "Financial Psychology",
      image: "trading"
    },
    {
      title: "Counselling Skills 101",
      description: "Online programme teaching practical counselling skills.",
      link: "https://happylab.app/counselling-skills/",
      category: "Education",
      image: "counselling101"
    }
  ],

  contentCreator: {
    title: "Content Creator",
    description: "Creating research-based content about psychology, relationships, and human behavior",
    stats: [
      { number: "6+", label: "Years Creating Content" },
      { number: "14K+", label: "Instagram Community" },
      { number: "15", label: "Podcast Episodes" },
      { number: "50+", label: "Educational Videos" }
    ],
    topics: [
      "Mental Wellness",
      "Relationship Psychology",
      "Founder Psychology",
      "Educational Videos",
      "Research-based Storytelling",
      "Talking Head Videos",
      "Podcasts"
    ],
    platforms: {
      youtube: "https://www.youtube.com/@vandanasubramanian",
      instagram: "https://www.instagram.com/vandanasaidso/",
      spotify: "#",
      podcast: "https://www.youtube.com/@vandanasubramanian"
    }
  },

  interests: [
    "Psychology",
    "Relationship Science",
    "Trading Psychology",
    "Founder Psychology",
    "History",
    "City Planning",
    "Travel",
    "Culture",
    "Human Behaviour",
    "Marketing",
    "AI & SEO"
  ],

  timeline: [
    {
      year: "2019",
      title: "The Beginning",
      events: [
        "Started psychology content",
        "Founded Happy Lab",
        "Masters in Clinical Psychology"
      ]
    },
    {
      year: "2020",
      title: "Professional Practice",
      events: [
        "Started counselling professionally",
        "Launched educational courses"
      ]
    },
    {
      year: "2021",
      title: "Growth",
      events: [
        "Expanded counselling services",
        "Corporate workshops"
      ]
    },
    {
      year: "2022",
      title: "Scaling",
      events: [
        "Built physical counselling centre",
        "Expanded team"
      ]
    },
    {
      year: "2024",
      title: "Innovation & Recognition",
      events: [
        "Won Best Business Idea in 10K Women Program",
        "Created happylab.app",
        "Created learn.happylab.app",
        "Expanded into educational technology"
      ]
    },
    {
      year: "2025+",
      title: "New Horizons",
      events: [
        "Started Cityology",
        "Creating videos about history, cities and urban planning"
      ]
    }
  ],

  lifeBeyondWork: {
    title: "Life Beyond Work",
    description: "When I'm not working, you'll find me...",
    activities: [
      { activity: "Travelling", description: "Exploring new places and cultures" },
      { activity: "Understanding Cultures", description: "Learning about different ways of living" },
      { activity: "Trying Local Cuisines", description: "Food is the best way to understand a place" },
      { activity: "Walking Through Old Cities", description: "History comes alive in architecture" },
      { activity: "Board Games", description: "Strategy and fun with friends" },
      { activity: "Reading", description: "Always learning something new" }
    ]
  },

  speaking: {
    title: "Speaking & Podcasts",
    description: "Sharing ideas through conversations and workshops",
    events: [
      { 
        type: "Podcast Host", 
        title: "Happy Lab Podcast", 
        description: "Conversations about psychology and life",
        link: "https://youtu.be/7pvqjWVP7bc?si=KL0eU3BlF_PweEQY"
      },
      { 
        type: "Podcast Host", 
        title: "Founder Psychology Series", 
        description: "Hosting conversations about mental health for entrepreneurs",
        link: "https://www.youtube.com/watch?v=ACUHJPW4tKU&list=PLMBQGgPcBNWR7u0ZHBEbw27zy9GpUBuBE"
      },
      { 
        type: "Award Winner", 
        title: "Part of 10k Women (Goldman Sachs) cohort", 
        description: "Best business idea award",
        link: "#"
      },
      { 
        type: "Speaker", 
        title: "Events and Speaker in Colleges", 
        description: "Psychology and mental health talks",
        link: "#"
      }
    ]
  },

  writing: {
    title: "Writing",
    description: "Thoughts, research, and stories published on Happiest Health and LinkedIn",
    featured: [
      {
        title: "High Functioning Depression",
        category: "Mental Health",
        excerpt: "Understanding the silent struggle of high-functioning depression and how to recognize the signs",
        readTime: "8 min read",
        date: "Published in Happiest Health",
        link: "https://www.happiesthealth.com/articles/mental-health/high-functioning-depression"
      },
      {
        title: "Mental Health New Year Resolution 2023",
        category: "Mental Health",
        excerpt: "Setting meaningful mental health goals for the new year",
        readTime: "6 min read",
        date: "Published in Happiest Health",
        link: "https://www.happiesthealth.com/articles/mental-health/mental-health-new-year-resolution-2023"
      },
      {
        title: "Countdown to Calmness: 5 Steps to Tame Anxiety",
        category: "Anxiety",
        excerpt: "Practical steps to manage anxiety and find inner calm",
        readTime: "7 min read",
        date: "Published in Happiest Health",
        link: "https://www.happiesthealth.com/articles/general/countdown-to-calmness-5-steps-to-tame-anxiety"
      },
      {
        title: "From Chaos to Calm: How CBT Can Help",
        category: "Therapy",
        excerpt: "Understanding how Cognitive Behavioral Therapy can help manage stress and anxiety",
        readTime: "10 min read",
        date: "Published in Happiest Health",
        link: "https://www.happiesthealth.com/articles/mental-health/from-chaos-to-calm-how-cbt-can-help-you-manage-stress-and-anxiety"
      },
      {
        title: "10 Things to Know in Your 20s",
        category: "Life Advice",
        excerpt: "Essential insights for navigating your twenties with confidence",
        readTime: "12 min read",
        date: "Published in Happiest Health",
        link: "https://www.happiesthealth.com/articles/mental-health/10-things-to-know-in-your-20s"
      },
      {
        title: "Anxiety: How to Tame Lasting Fears",
        category: "Anxiety",
        excerpt: "Strategies for managing persistent fears and anxiety",
        readTime: "9 min read",
        date: "Published in Happiest Health",
        link: "https://www.happiesthealth.com/articles/mental-health/anxiety-how-tame-lasting-fears"
      },
      {
        title: "LinkedIn Posts",
        category: "Professional Insights",
        excerpt: "Follow my thoughts on psychology, entrepreneurship, and mental health on LinkedIn",
        readTime: "Quick reads",
        date: "Published on LinkedIn",
        link: "https://www.linkedin.com/in/vandana-subramanian/"
      }
    ]
  },

  testimonials: [
    {
      name: "Priya Sharma",
      role: "Client",
      content: "Working with Vandana changed how I see myself and my relationships. Her approach is both compassionate and practical.",
      avatar: "PS",
      image: "client1"
    },
    {
      name: "Rahul Mehta",
      role: "Trading Psychology Student",
      content: "The trading psychology programme helped me understand patterns I didn't even know existed. My decision-making has completely transformed.",
      avatar: "RM",
      image: "client2"
    },
    {
      name: "Anjali Verma",
      role: "Corporate Partner",
      content: "Vandana's workshops brought real value to our team. The combination of expertise and genuine care is rare.",
      avatar: "AV",
      image: "client3"
    },
    {
      name: "Karthik Reddy",
      role: "Psychology Student",
      content: "Learning counselling skills through Happy Lab gave me confidence I never thought I'd have. The feedback and supervision were invaluable.",
      avatar: "KR",
      image: "client4"
    }
  ],

  collaboration: {
    title: "Let's Build Something Together",
    description: "I'm always excited to work on meaningful projects. Whether you're looking for collaboration, speaking, or just want to chat about psychology and ideas.",
    opportunities: [
      "Brand Collaborations",
      "Speaking Engagements",
      "Workshops",
      "Podcast Interviews",
      "Mental Health Initiatives",
      "Content Creation",
      "Advisory",
      "Founder Coaching",
      "Trading Psychology Consulting"
    ]
  },

  contact: {
    email: "vana2254@gmail.com",
    linkedin: "https://www.linkedin.com/in/vandana-subramanian/",
    instagram: "https://www.instagram.com/vandanasaidso/",
    youtube: "https://www.youtube.com/@vandanasubramanian",
    happylab: "https://www.instagram.com/happylab.app/"
  }
};

export const siteSettings = {
  darkMode: true,
  smoothScroll: true,
  animatedCounters: true
};
